import { ReactElement, useEffect, useState } from "react";

interface Props {
    components: Record<string, any>,
    setTab?: (tabName: string) => void;
}

const TabComponent = ({components, setTab}: Props) => {
    const tabs = Object.keys(components);
    const [currentTab, setCurrentTab] = useState(tabs[0]);
    const Component = components[currentTab] ;

    const handleSetTab = (tab) => {
        setCurrentTab(tab);
        setTab && setTab(tab);
    }

    useEffect(() => {
        const tabs = Object.keys(components);
        handleSetTab(tabs[0]);
    }, [components]);

    return (
        <div className="w-full h-full px-8">
            <div className="w-full h-10 flex flex-row justify-start items-center border-b border-az-gray-120">
                {
                    tabs.map((tab) => (
                        <button
                            key={tab} onClick={() => handleSetTab(tab)}
                            className="w-fit min-w-[120px] mr-3 !rounded-none h-full "
                            style={{
                                borderBottom: currentTab === tab ? '4px solid #0898A0' : '4px solid transparent',
                            }}
                        >
                            {tab}
                        </button>
                    ))
                }
            </div>
            <div className="w-full flex flex-auto flex-grow">
                {Component && <Component />}
            </div>
        </div>
    )
}

export default TabComponent;
